import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { User, Tenant } from '../types'

interface AuthState {
  user: User | null
  tenant: Tenant | null
  token: string | null
  apiKey: string | null
  tenantId: string | null
  isAuthenticated: boolean
  authMethod: 'jwt' | 'apikey' | null
  setAuth: (user: User, tenant: Tenant, token: string, method?: 'jwt' | 'apikey') => void
  setApiKeyAuth: (apiKey: string, tenantId: string, user: User, tenant: Tenant) => void
  logout: () => void
  updateUser: (user: Partial<User>) => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      tenant: null,
      token: null,
      apiKey: null,
      tenantId: null,
      isAuthenticated: false,
      authMethod: null,
      setAuth: (user, tenant, token, method = 'jwt') =>
        set({ 
          user, 
          tenant, 
          token, 
          apiKey: null,
          tenantId: null,
          isAuthenticated: true,
          authMethod: method 
        }),
      setApiKeyAuth: (apiKey, tenantId, user, tenant) =>
        set({
          user,
          tenant,
          token: null,
          apiKey,
          tenantId,
          isAuthenticated: true,
          authMethod: 'apikey'
        }),
      logout: () =>
        set({ 
          user: null, 
          tenant: null, 
          token: null, 
          apiKey: null,
          tenantId: null,
          isAuthenticated: false,
          authMethod: null
        }),
      updateUser: (updates) =>
        set((state) => ({
          user: state.user ? { ...state.user, ...updates } : null,
        })),
    }),
    {
      name: 'mindcore-auth',
    }
  )
)
